<template>
    <div class="waper">
        <div class="header">
            <img src="../assets/Img/logo3.png" style="position: fixed; top: 8px; width: 27%; height: auto; margin-left: 3%; "/>
            <div style="position: absolute;right: 3%;top: 8px;color: #fefefe;line-height: 40px; font-size: 12px;" v-if="loginData" >
                <div class="navTitle" @click="loginOut">退出</div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" @click="toHelp">帮助</div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" @click="toUpload">捐赠</div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" v-text="loginData" @click="personInfo">欢迎您！华中师范大学</div>
                <div class="navTitle_line" style="cursor: pointer;"  @click="personInfo">
                    <img style="width: 30px; height: 30px; margin-top: 6px;" src="../assets/Img/person/avator.png" />
                </div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" @click="toList">年鉴</div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" @click="toIndex">首页</div>
            </div>
            <div style="position: absolute;right: 3%;top: 8px;color: #fefefe;line-height: 40px;cursor:pointer; font-size: 12px;" v-else>
                <div class="navTitle" style="margin-right: 30px;" @click="toHelp">帮助</div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" @click="toRegister">注册</div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" @click="toLogin">登录</div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" @click="toList">年鉴</div>
                <div class="navTitle_line" >|</div>
                <div class="navTitle" @click="toIndex">首页</div>
            </div>
        </div>
        <div class="banner">
            <div style="height: 40px;overflow: hidden;line-height: 40px;margin-left: 3.5%; width: 40%; display: inline-block;">
                <img src="../assets/Img/newsPic.png">
                <ul id="line">
                    <li style="font-size: 13px;margin-left: 30px;color: #F3FC68;cursor: pointer">11111111</li>
                    <li style="font-size: 13px;margin-left: 30px;color: #F3FC68;cursor: pointer">22222222</li>
                    <li style="font-size: 13px;margin-left: 30px;color: #F3FC68;cursor: pointer">33333333</li>
                </ul>
            </div>
            <div style="position: absolute;top:53%;left:31%;width: 37%">
                <el-input  @keyup.enter.native="keyEnter"  placeholder="请输入关键字">
                    <el-button slot="append" @click="toKeywords" style="height: 40px;line-height: 40px;width: 50px;background-color:#3ca0eb;color: #FFFFFF;margin: -1px -22px" icon="el-icon-search"></el-button>
                </el-input>
            </div>
            <div class="scannum">
                <p>
                    <img class="scanpic" src="../assets/Img/countday.png">
                    <span class="scantext">今日浏览数：9527次</span>
                </p>
                <p>
                    <img class="scanpic" src="../assets/Img/countall.png">
                    <span class="scantext">总浏览数：1008611次</span>
                </p>
            </div>
            <img src="../assets/Img/nqText.png" style="width: 3%;position: absolute;left: 30%;top: 31%">
            <img src="../assets/Img/nqPic.png" style="width: 35%;position: absolute;left: 34%;top: 26%">
        </div>
        <el-dialog title="使用声明" :visible.sync="dialogTableVisible" style="text-align: left; " center>
            <p class="dialogcontent">1、本数据库为非营利性的公益数据库，使用本数据库不需要支付任何费用。</p>
            <p class="dialogcontent">2、本数据库提供的地方志资料，均仅供参考。本数据库将尽力确保所提供资料的真实性，但不保证具体内容的准确性及可靠性，本数据库对有关资料所引致的错误、不确或遗漏，概不负任何法律责任。</p>
            <p class="dialogcontent">3、本数据库为我们购买、获赠，以及从网上公开渠道下载的数据汇集，任何单位或个人认为本数据库中的内容侵犯其知识产权，请及时向本数据库提出书面权利通知，并提供身份证明、权属证明及详细侵权情况证明。本数据库在收到上述法律文件后，将会依法尽快修改或者删除相关内容。</p>
            <p class="dialogcontent">4、本数据库尊重并保护所有用户的个人隐私权，您注册的用户名、电子邮件地址等个人资料，非经您亲自许可或根据相关法律、法规的强制性规定，本数据库不会主动地泄露给第三方。</p>
            <p class="dialogcontent">5、中国农村研究院地方志数据库致力于提供最全面的中国地方志资料，我们欢迎社会各界人士前来数据库查阅各地地方志及相关资料，我们将竭力为您提供帮助。</p>
            <p class="dialogcontent">6、中国农村研究院地方志数据库处于持续更新中，我们欢迎各单位和社会各界人士通过捐赠、寄存等方式将地方志存放于本单位，若取得许可我们将录入数据库进行永久保存。中国地方志数据库真诚期待您的到来！</p>
            <span slot="footer" class="dialog-footer" style="padding: 10px;">
				<el-button @click="dialogTableVisible = false" style="padding: 10px;">取 消</el-button>
				<el-button @click="dialogTableVisible = false" style="padding: 10px;">确 定</el-button>
			</span>
        </el-dialog>
        <div class="foot">
            <p style="width: 19%">版权所有：华中师范大学中国农村研究院 <span @click="dialogTableVisible = true" style="color: #45d7dc;font-weight: bold; cursor: pointer;">使用声明</span></p>
            <p style="width: 26%">Copyright©2014-2018CCRS.All Rights Reserved. 鄂ICP备05003325号-6</p>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    require("../assets/jquery.js");
    import {request} from '../API/ApiUrl.js';
    export default {
        name: "index1",
        data(){
            return{
                loginData:"",
                dialogTableVisible:false
            }
        },
        mounted(){
            this.scrollNews()
        },
        methods:{
            toUpload() {

            },
            toHelp() {

            },
            toIndex() {

            },
            toList() {

            },
            toRegister() {

            },
            toLogin() {

            },
            loginOut() {

            },
            personInfo() {

            },

            keyEnter(){

            },
            toKeywords(){},

            scrollNews(){
                function Scroll(){}
                $(function () {
                    myScroll.upScroll("line","-40px",3000);
                })

                Scroll.prototype.upScroll=function(dom,_h,interval){
                    var dom=document.getElementById(dom);
                    var timer=setTimeout(function(){
                        var _field=dom.firstElementChild;
                        _field.style.marginTop=_h;
                        clearTimeout(timer);
                    },1000)
                    setInterval(function(){
                        var _field=dom.firstElementChild;
                        _field.style.marginTop="0px";
                        dom.appendChild(_field);
                        var _field=dom.firstElementChild
                        _field.style.marginTop=_h;
                    },interval)
                }

                var myScroll=new Scroll();
            }
        }
    }
</script>

<style scoped>
    *{
        margin: 0;
        padding: 0;
    }
    .waper{
        width: 100%;
        height: 100%;
    }
    .header{
        width: 100%;
        height: 7%;
        background-color: #024DB6;
        opacity:0.8;
        position: relative;
    }
    .navTitle{
        float: right;
        margin-left: 10px;
        font-size: 15px;
        font-weight: 500;
        cursor: pointer;
    }
    .navTitle:hover{
        color: #00f1ff;
        border-bottom: 2px solid #10e8fa;
    }
    .navTitle_line{
        float: right;
        margin-left: 10px;
        font-size: 15px;
        font-weight: bold;
    }
    .banner{
        width: 100%;
        height: 85%;
        position: relative;
        background: url("../assets/Img/nqBanner.jpg") 0 0 no-repeat;
        background-size:100% 100%; ;
    }
    .foot{
        width: 100%;
        height: 8%;
        background-color: #0C54B0;
    }
    .foot p{
        font-size: 12px;
        color: #FFFFFF;
        margin: -1px auto;
        padding-top: 10px;
    }
    .scannum{
        display: inline-block;
        float: right;
        width: 13%;
        font-size: 13px;
        margin-top: 10px;
        color: #e6eb7c;
        line-height: 30px;
    }
    .scanpic{
        height: 17px;
        width: 17px;
        vertical-align: middle;
    }
    .scantext{
        vertical-align: middle;
        padding-left: 10px;
    }
    .dialogcontent{
        color: #4c8d8c;
        margin: 10px 0;
    }
</style>